<template>
  <div id="financial-data" class="kp-flat-card small-shadow">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="General Information" name="general-information">
        <general-information-form @next="activeTab = 'payout-settlements'"></general-information-form>
      </el-tab-pane>
      <el-tab-pane label="Payout Settlements" name="payout-settlements">
        <payout-settlements-form @next="activeTab = 'personal-information'"></payout-settlements-form>
      </el-tab-pane>
      <el-tab-pane label="Personal Information" name="personal-information">
        <personal-information-form @next="step = 4"></personal-information-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import GeneralInformationForm from '@/components/register/GeneralInformationForm.vue'
import PersonalInformationForm from '@/components/register/PersonalInformationForm.vue'
import PayoutSettlementsForm from '@/components/register/PayoutSettlementsForm.vue'

export default {
  name: 'financial-data',
  components: {
    GeneralInformationForm,
    PersonalInformationForm,
    PayoutSettlementsForm
  },
  computed: {
    ...mapFields({
      step: 'registration.step'
    })
  },
  data() {
    return {
      activeTab: 'general-information'
    };
  },
}
</script>
